<div class:backdrop={/* anchor for external customization */ true} {...$$restProps} />

<style lang="postcss">
  * {
    @apply pointer-events-none absolute inset-0 flex h-full w-full items-center justify-center opacity-40;

    &::before {
      @apply absolute top-[1px] aspect-[336/389] h-[calc(100%-2px)] w-auto content-[""];

      box-shadow: 0px 0px 0 100vmax black;
    }

    &::after {
      @apply absolute top-0 aspect-[336/389] h-full w-auto bg-black content-[""];

      mask: linear-gradient(to right, #000, #000),
        url("./ellipse-filled.svg") center / auto 100% no-repeat;
      mask-composite: exclude;
    }
  }
</style>
